<template>
<div>
    <section>
        <b-field  position="is-right">
            <b-input placeholder="Search..." type="search" icon="search" v-model="search">
            </b-input>
            <p class="control">
                <b-dropdown class="hover-rotate-90" hoverable aria-role="list" position="is-bottom-left" :disabled="toggleDelete">
                    <button class="button is-primary" slot="trigger">
                        <b-icon icon="plus" pack="fal"></b-icon>
                    </button>

                    <b-dropdown-item v-for="type in locationTypes" aria-role="listitem" @click="addLocation({name:type.default,type:type.name},true)">
                        <b-icon :icon="icon(type.name)" pack="fad"></b-icon> {{type.title}}
                    </b-dropdown-item>
                </b-dropdown>
            </p>
            <p class="control">
                <button class="button is-danger" @click="toggleDelete = !toggleDelete">
                    <b-icon icon="minus" pack="fal"></b-icon>
                </button>
            </p>
        </b-field>

    </section>
    <section>
        <Draggable :list="$root.event.locations" group="locations" :options="{handle:'.draggy'}">
            <div class="arrangement-cards">
                <div class="card is-grid" v-for="location in filtered" :class="{ giggly: toggleDelete }">
                    <header class="card-header">
                        <p class="card-header-title">
                            <b-icon v-if="!toggleDelete" :icon="icon(location.type)" pack="fad" :class="{ draggy: toggleDrag }" class="icon-fix"></b-icon>
                            <a v-else @click="removeLocation(location)">
                                <b-icon icon="minus-circle" pack="fas" type="is-danger"></b-icon>
                            </a>
                            <span>{{location.name}}</span>
                        </p>
                    </header>
                    <div class="card-content">
                        <div class="content">
                            <p v-if="location.description">{{location.description}}</p>
                            <p>{{location.location}}</p>

                        </div>
                    </div>
                    <footer class="card-footer">
                        <a class="card-footer-item" @click="editLocation(location)">
                            <b-icon pack="fad" icon="edit" size="is-small"></b-icon>
                        </a>
                        <a class="card-footer-item" @click="addLocation(location)" title="Duplizieren">
                            <b-icon pack="fad" icon="clone" size="is-small"></b-icon>
                        </a>

                    </footer>
                </div>
            </div>
        </Draggable>
    </section>
    <b-modal :active.sync="isCardModalActive" scroll="keep" @close="saveLocation()">
        <div class="card is-modal">
            <header class="card-header">
                <p class="card-header-title">
                    <b-icon :icon="icon(editableLocation.type)" pack="fad"></b-icon>&nbsp;&nbsp;{{editableLocation.name}}
                </p>
            </header>
            <div class="card-content">

                <div class="content">
                    <b-field horizontal label="Name"  class="field-grid">
                        <b-input v-model="editableLocation.name"></b-input>
                        <b-select v-model="editableLocation.type" placeholder="Bitte wählen Sie den Typ:" :icon="icon(editableLocation.type)">
                            <option v-for="type in locationTypes" :value="type.name">
                                {{type.title}}
                            </option>
                        </b-select>
                    </b-field>
                    <b-field label="Beschreibung" horizontal>
                        <b-input maxlength="2000" v-model="editableLocation.description" type="textarea"></b-input>
                    </b-field>
                    <b-field horizontal label="Ortsangabe / Adresse">
                        <b-input maxlength="2000" v-model="editableLocation.location" type="textarea"></b-input>
                    </b-field>
                    <b-button type="is-success" @click="saveLocation()">Speichern</b-button>
                </div>
            </div>
        </div>
    </b-modal>
</div>
</template>

<script>
export default {
    name: 'Locations',
    components: {

    },
    props: {

    },
    data() {
        return {
            toggleDelete: false,
            toggleDrag: true,
            search: '',
            isCardModalActive: false,
            editableLocation: {},
            locationTypes: [{
                    title: 'Location',
                    icon: 'map-marker-alt',
                    name: 'main',
                    default: 'neue Location'
                },
                {
                    title: 'Gebäude',
                    icon: 'building',
                    name: 'building',
                    default: 'neues Gebäude'
                }
            ]
        }
    },
    methods: {
        update(id = this.$route.params.id) {
            return true
        },
        saveEvent() {
            this.$root.saveEvent(this.$route.params.id)
        },
        addLocation(template = {}, init = false) {
            let location = {}
            location = Object.assign(location, template)
            location.id = ++this.$root.event.counter.locations
            if (!location.name) {
                location.name = 'Neuer Location'
            } else if (!init) {
                location.name += ' Kopie'
            }
            if (!location.type) {
                location.type = 'misc'
            }
            this.$root.event.locations.push(location)
            this.saveEvent()
        },
        editLocation(location) {
            this.isCardModalActive = true
            this.editableLocation = location

        },
        saveLocation() {
            this.isCardModalActive = false
            this.$root.saveEvent(this.$route.params.id, true)
        },
        icon(type = 'main') {
            let find = this.locationTypes.find(function (element) {
                return element.name == type
            })
            return find.icon
        },
        removeLocation(old) {
            this.$buefy.dialog.confirm({
                title: 'Location löschen?',
                message: 'Sind Sie sicher, dass Sie die <br>Location <b><i>' + old.name + '</i> löschen</b> möchten?<br>Diese Aktion kann nicht Rückgängig gemacht werden.',
                confirmText: 'Location löschen',
                type: 'is-danger',
                hasIcon: true,
                onConfirm: () => {
                    let wksps = []
                    this.$root.event.locations.forEach(function (element) {
                        if(element.id !== old.id){
                            wksps.push(element)
                        }
                    });
                    this.$root.event.locations = wksps
                    this.saveEvent()
                    this.$buefy.toast.open({
                        message: 'Die Location <b>' + old.name + '</b> wurde gelöscht',
                        type: 'is-success'
                    })
                }
            })
        }
    },
    created() {
        // fetch the data when the view is created and the data is
        // already being observed

        this.update()
    },
    computed: {
        filtered() {
            var origin = this.$root.event.locations,
                filtered = [],
                patt = new RegExp(this.search, "i");
            this.toggleDrag = true
            if (this.search == '') {
                return origin
            }
            if (this.search.length < 3) {
                return origin
            }
            this.toggleDrag = false
            origin.forEach(entry => {
                if (patt.test(entry.name)) {
                    filtered.push(entry)
                    return
                }
                if (patt.test(entry.description)) {
                    filtered.push(entry)
                    return
                }
                if (patt.test(entry.location)) {
                    filtered.push(entry)
                    return
                }
            })
            return filtered
        }
    }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
.c-preview {
    width: 50px;
}

.hover-rotate-90 .dropdown-trigger .icon i {
    transition: transform .8s ease;
}

.hover-rotate-90.is-active .dropdown-trigger .icon i,
.hover-rotate-90:hover .dropdown-trigger .icon i {
    transform: rotate(90deg);
}

.card.is-grid {
    display: inline-block;
    width: 250px;
    margin: 20px;
    vertical-align: top;
}

.card.is-modal {
    min-width: 270px;
    margin: 20px;
}

.event-list {
    text-align: center;
}

.giggly {
    transition: transform .05s ease;
    animation-name: giggle;
    animation-duration: .2s;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
}

@keyframes giggle {
    0% {
        transform: rotate(0deg);
    }

    25% {
        transform: rotate(-1deg);
    }

    50% {
        transform: rotate(0deg);
    }

    75% {
        transform: rotate(1deg);
    }

    1000% {
        transform: rotate(0deg);
    }
}
</style>
